import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

// The /api/* routes now require a Cognito access token. Rather than threading a
// token argument through every call site, attach it here once.
//
// Amplify caches the current session and refreshes it when the access token has
// expired, so calling fetchAuthSession() per request is cheap and keeps us from
// sending a stale token after a long idle period.
const api = axios.create();

api.interceptors.request.use(async (config) => {
  try {
    // v3's currentSession() rejected when signed out; v6's fetchAuthSession
    // resolves with no tokens instead, so the absence has to be checked.
    const { tokens } = await fetchAuthSession();
    if (tokens) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${tokens.accessToken.toString()}`,
      };
    }
  } catch (e) {
    // No signed-in user. Let the request go out unauthenticated and fail with a
    // 401 from the server, which the caller already handles as an error.
  }
  return config;
});

export default api;
